const defaultPrevieStyle = {
  margin: '15px 2px',
};

export const imagePreviewStyle = {
  maxWidth: '100%',
  height: 'auto',
};

export default defaultPrevieStyle;



// WEBPACK FOOTER //
// ./components/Widgets/defaultPreviewStyle.js